<style lang="less">
  @import "~@/public/less/index.less";
  .zee-table{
    .ant-table-pagination.ant-pagination{
      margin: 20px 0 0 0;
    }
  }

  .ant-spin-nested-loading > div > .ant-spin{
    max-height: 100%;
  }
//   .ant-pro-components-tag-select {
//   /deep/ .ant-pro-tag-select .ant-tag {
//     margin-right: 24px;
//     padding: 0 8px;
//     font-size: 14px;
//   }
// }
// .ant-pro-pages-list-projects-cardList {
//   margin-top: 24px;

//   /deep/ .ant-card-meta-title {
//     margin-bottom: 4px;
//   }

//   /deep/ .ant-card-meta-description {
//     height: 44px;
//     overflow: hidden;
//     line-height: 22px;
//   }

  .cardItemContent {
    display: flex;
    height: 20px;
    margin-top: 16px;
    margin-bottom: -4px;
    line-height: 20px;

    > span {
      flex: 1 1;
      color: rgba(0,0,0,.45);
      font-size: 12px;
    }

    /deep/ .ant-pro-avatar-list {
      flex: 0 1 auto;
    }
  }
// }
</style>

<template>
  <div class="zee zee-component zee-table">
    <a-spin :spinning="superLoading"  tip="加载中..." >
      <a-icon slot="indicator" type="loading" style="font-size: 24px;" spin />
      <a-list 
        v-if="columns && superData && superFilter && data && data.data && data.data.data"
        :data-source="data.data.data" 
        :grid="{ gutter: 24, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }"
        :columns="columns"
        :pagination="{
        total: parseInt(data.data.count),
        current: parseInt(superFilter.page || 1),
        defaultPageSize: parseInt(superFilter.limit || 12),
        showTotal: total => `共${total}行`,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions:['12','24','48','60','72','84'],
        onChange:bindTableChange,
        onShowSizeChange:bindTableChange
        }"
      >
      <a-list-item slot="renderItem" slot-scope="item">
          <slot name="listbody" :record="item"></slot>
          <!-- <slot name="actions" :record="item"></slot> -->
          <a-card style="border-top:none;margin-top:-1px;">
              <template slot="actions">
                  <slot name="actions" :record="item"></slot>
              </template>
          </a-card>
      </a-list-item>
        
      <!-- <slot name="listbody" slot-scope="item"></slot> -->
        <!-- <a-list-item slot="renderItem" slot-scope="item">
          <a-card class="ant-pro-pages-list-projects-card" hoverable>
            <img slot="cover" :src="item.feature || require('@/assets/image/nopic.jpg')" :alt="item.feature" />
            <a-card-meta :title="item.name">
              <template slot="description">
                {{ item.name }}
              </template>
            </a-card-meta>
            <div class="cardItemContent">
              <span>{{ item.sfz }}</span>
            </div>
            <template slot="actions">
                <slot name="actions" :record="item"></slot>
            </template>
            <div>
            </div>
          </a-card>
        </a-list-item> -->
      </a-list>
    </a-spin>
  </div>
</template>

<script>
  export default {
    name: 'FCardList',
    props: {
      superLoading: Boolean,
      superData: Object,
      superColumns: Array,
      superFilter: Object,
      rowSelection: Object
    },
    // async created() {
    //   if (this.superData) {
    //     await this.loadData()
    //   }
    // },
    computed: {
      columns() {
        const state = this.$store.state
        if (state.page) {
          const {tableColumns} = state.page
          const columns = []
          for (let k in tableColumns) {
            const column = tableColumns[k]
            if (!column.hidden || column.hidden.indexOf('list')<0) {
              columns.push(column)
            }
          }
          // console.log('columns', columns)
          return columns
        } else {
          return Array
        }
      },
      data() {
        const data = this.$store.state.page
        return this.$fan.utils.parse(data)
      }
    },
    // data() {
    //   return {
    //     data: {},
    //     def: {
    //       data: {}
    //     }
    //   }
    // },
    methods: {
      async loadData() {
        // const data = this.$fan.storage.getStorage('zee-page')
        // const data = this.$store.state.page
        // this.data = this.$fan.utils.parse(data)
        // console.log(this.data)
        // const superData = this.$fan.utils.parse(this.superData)
        // this.data.data = superData.data
      },
      bindTableChange (pagination, filters, sorter) {
        // '@showSizeChange': e => bindChangeLimit(e),
        // console.log('debug:'+pagination+',f:'+filters)
        this.$emit('change', pagination, filters, sorter)
      },
      bindpicPreview(file) {
        this.visible = true
        this.picview = file
      },
      bindpicPreviewCancle() {
        this.picview = false
      },
      bindDownload(url) {
        window.open(url, '_blank')
      }
    }
  }
</script>
